import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ReadyToJoin() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="30889" id="final-calltoaction" ref={ref} className="dark text-foreground py-24 relative overflow-hidden !bg-[hsl(0,0%,100%)]">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-24 left-1/4 w-[600px] h-[600px] bg-primary/5 rounded-full blur-[150px] opacity-20" />
        <div className="absolute -bottom-24 right-1/4 w-[600px] h-[600px] bg-[#2B5AA6]/10 rounded-full blur-[150px] opacity-20" />
      </div>

      <div className={cn("container mx-auto px-4 relative z-10 max-w-4xl text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h2 className="text-4xl font-bold tracking-tight mb-6 !bg-transparent !text-[hsl(222,47%,11%)] md:text-5xl lg:text-6xl">Need Coverage?</h2>

        <p className="text-xl md:text-2xl text-[#2B5AA6] mb-10 max-w-2xl mx-auto leading-relaxed font-medium">Atlas Surgical Partners delivers reliable surgical staffing support when you need it most. We bridge the gap between elite surgical talent and premier medical facilities across the nation.</p>

        <div className="flex flex-col items-center gap-6">
          <Button asChild size="lg" className="h-auto text-lg px-10 py-4 rounded-full bg-gradient-to-r from-[#0B1F3A] via-[#2B5AA6] to-[#0B1F3A] hover:bg-none hover:bg-[#F2C94C] text-white hover:text-[#0B1F3A] font-semibold shadow-xl shadow-black/30 transition-all hover:scale-105 border border-white/10">
            <Link to="/facilities/">
              Request Coverage <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>

          
        </div>
      </div>
    </section>;
}